import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import {
  AddDataQualityIndicatorRequest,
  IAddDataQualityIndicatorParams
} from '../ServerApi/requests/AddDataQualityIndicatorRequest';
import {
  IUpdateDataQualityIndicatorParams,
  UpdateDataQualityIndicatorRequest
} from '../ServerApi/requests/UpdateDataQualityIndicatorRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { ToasterService, ToastType } from './ToasterService';

export class DataQualityService {
  public static $inject = [
    'ErrorNotifyingServer'
  ];

  constructor(
    private ErrorNotifyingServer: ErrorNotifyingServer,
  ) { }

  private readonly toast = (result: IResult, contentName: string, message: string): any => {
    if (result.errors && result.errors.length > 0) {
      ToasterService.instance.pop({
        type: ToastType.Error,
        text: Messages.dataQuality_setError({CONTENT_NAME: contentName})
      });
    } else {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: message
      });
    }
  }

  public readonly addDataQualityWarning = async (args: IAddDataQualityIndicatorParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new AddDataQualityIndicatorRequest(args))
      .then(r => {
        return this.toast(r, args.contentName, Messages.dataQuality_addSuccess({CONTENT_NAME: args.contentName}));
      });
  }

  public readonly updateDataQualityWarning = async (args: IUpdateDataQualityIndicatorParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new UpdateDataQualityIndicatorRequest(args))
      .then(r => {
        return this.toast(r, args.contentName, Messages.dataQuality_updateSuccess({CONTENT_NAME: args.contentName}));
      });
  }
}

Module.instance().service('DataQualityService', DataQualityService);
